const TIPOS_DOCUMENTO_REFERENCIA = [
  { value: "30", label: "Factura" },
  { value: "32", label: "Factura de venta bienes y servicios no afectos o exentos de IVA" },
  { value: "35", label: "Boleta" },
  { value: "38", label: "Boleta exenta" },
  { value: "45", label: "Factura de compra" },
  { value: "48", label: "Comprobante de pago electrónico" },
  { value: "55", label: "Nota de débito" },
  { value: "60", label: "Nota de crédito" },
  { value: "103", label: "Liquidación" },
  { value: "40", label: "Liquidación Factura" },
  { value: "43", label: "Liquidación-Factura Electrónica" },
  { value: "33", label: "Factura Electrónica" },
  { value: "34", label: "Factura No Afecta o Exenta Electrónica" },
  { value: "39", label: "Boleta Electrónica" },
  { value: "41", label: "Boleta Exenta Electrónica" },
  { value: "46", label: "Factura de Compra Electrónica" },
  { value: "56", label: "Nota de Débito Electrónica" },
  { value: "61", label: "Nota de Crédito Electrónica" },
  { value: "50", label: "Guía de Despacho" },
  { value: "52", label: "Guía de Despacho Electrónica" },
  { value: "110", label: "Factura de Exportación Electrónica" },
  { value: "111", label: "Nota de Débito de Exportación Electrónica" },
  { value: "112", label: "Nota de Crédito de Exportación Electrónica" },
  { value: "801", label: "Orden de Compra" },
  { value: "HES", label: "HES (Hoja de Entrada de Servicio)" },
  { value: "802", label: "Nota de pedido" },
  { value: "803", label: "Contrato" },
  { value: "804", label: "Resolución" },
  { value: "805", label: "Proceso ChileCompra" },
  { value: "806", label: "Ficha ChileCompra" },
  { value: "807", label: "DUS" },
  { value: "808", label: "B/L (Conocimiento de embarque)" },
  { value: "809", label: "AWB (Air Waybill)" },
  { value: "810", label: "MIC/DTA" },
  { value: "811", label: "Carta de Porte" },
  { value: "812", label: "Resolución del SNA donde califica Servicios de Exportación" },
  { value: "813", label: "Pasaporte" },
  { value: "814", label: "Certificado de Depósito Bolsa Prod. Chile" },
  { value: "815", label: "Vale de Prenda Bolsa Prod. Chile" },
  { value: "820", label: "Código de Inscripción en el Registro de Acuerdos con Plazo de Pago Excepcional" },
  { value: "821", label: "Geo Referencia Predio" },
  { value: "822", label: "ROL Avalúo Predio" },
  { value: "823", label: "Plan de Manejo - CONAF" },
];

// Referencias válidas para notas de crédito/débito. En la práctica una nota solo
// anula o corrige facturas, boletas y otras notas, así que se acota el select a
// esos DTE en vez de ofrecer el catálogo completo del SII.
const CODIGOS_REFERENCIA_NOTA = ['33', '34', '39', '41', '56', '61'];

export const TIPOS_REFERENCIA_NOTA = TIPOS_DOCUMENTO_REFERENCIA.filter((t) =>
  CODIGOS_REFERENCIA_NOTA.includes(t.value),
);

export default TIPOS_DOCUMENTO_REFERENCIA;
